<template>
  <div class="v-culture" id="v-culture">
    <div class="header">
      <h2>{{$t('AboutText.p5_title')}}</h2>
    </div>
    <div class="content">
      <div class="box active">
        <img class="icon" src="../../assets/images/about/p5-1-1.png"/>
        <img class="icon-hover" src="../../assets/images/about/p5-1-1-hover.png"/>
        <h5>{{$t('AboutText.p5_1_1')}}</h5>
        <div class="info">
          <p>{{$t('AboutText.p5_1_2_1')}}</p>
          <p>{{$t('AboutText.p5_1_2_2')}}</p>
          <template v-if="isEng">
            <p>{{$t('AboutText.p5_1_2_3')}}</p>
          </template>
        </div>
      </div>
      <div class="box">
        <img class="icon" src="../../assets/images/about/p5-1-2.png"/>
        <img class="icon-hover" src="../../assets/images/about/p5-1-2-hover.png"/>
        <h5>{{$t('AboutText.p5_2_1')}}</h5>
        <div class="info">
          <p>{{$t('AboutText.p5_2_2_1')}}</p>
          <p>{{$t('AboutText.p5_2_2_2')}}</p>
          <template v-if="isEng">
            <p>{{$t('AboutText.p5_2_2_3')}}</p>
          </template>
        </div>
      </div>
      <div class="box">
        <img class="icon" src="../../assets/images/about/p5-1-3.png"/>
        <img class="icon-hover" src="../../assets/images/about/p5-1-3-hover.png"/>
        <h5>{{$t('AboutText.p5_3_1')}}</h5>
        <div class="info">
          <p>{{$t('AboutText.p5_3_2_1')}}</p>
          <p>{{$t('AboutText.p5_3_2_2')}}</p>
          <template v-if="isEng">
            <p>{{$t('AboutText.p5_3_2_3')}}</p>
          </template>
        </div>
      </div>
      <div class="box">
        <img class="icon" src="../../assets/images/about/p5-1-4.png"/>
        <img class="icon-hover" src="../../assets/images/about/p5-1-4-hover.png"/>
        <h5>{{$t('AboutText.p5_4_1')}}</h5>
        <div class="info">
          <p>{{$t('AboutText.p5_4_2_1')}}</p>
          <p>{{$t('AboutText.p5_4_2_2')}}</p>
          <p>{{$t('AboutText.p5_4_2_3')}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "p5-culture",
    mounted() {
      $('.v-culture .content').on('mouseover', '.box', function () {
        let $this = $(this);
        $this.siblings().removeClass('active');
        $this.addClass('active');
      });
    },
    computed: {
      isEng: function () {
        return this.$i18n.locale === 'en-US';
      }
    },
  }
</script>

<style scoped lang="scss">
  .en .v-culture {
    .content {
      .box {
        height: 16vw;
        padding: 3vw 1.68vw;

        .info {
          p {
            font-size: 0.80vw;
          }
        }
      }

    }
  }
</style>

<style scoped lang="scss">
  .v-culture {
    padding: 3vw 0 4vw;
    text-align: left;

    .header {
      margin-bottom: 5vw;
      text-align: center;

      h2 {
        font-size: 3.13vw;
        font-weight: bold;
      }
    }

    .content {
      display: flex;
      justify-content: center;

      .box {
        /*min-width: 216px;*/
        width: 18.59vw;
        height: 15.16vw;
        padding: 3vw 2vw;
        cursor: pointer;

        &.active {
          color: #ffffff;
          background-image: url('../../assets/images/about/p5-1-1-hover-bg.jpg');
          background-size: 100% 100%;

          &:nth-child(2) {
            background-image: url('../../assets/images/about/p5-1-2-hover-bg.jpg');
          }

          &:nth-child(3) {
            background-image: url('../../assets/images/about/p5-1-3-hover-bg.jpg');
          }

          &:nth-child(4) {
            background-image: url('../../assets/images/about/p5-1-4-hover-bg.jpg');
          }

          .icon {
            display: none;
          }

          .icon-hover {
            display: block;
          }
        }

        .icon {
          display: block;
        }

        .icon-hover {
          display: none;
        }

        img {
          width: 4vw;
          height: 2.8vw;
          margin-botom: 1.3vw;
        }

        h5 {
          margin-bottom: 1.2vw;
          font-size: 1.25vw;
          font-weight: bold;
          white-space: nowrap;
        }

        .info {
          font-size: 0.94vw;
          line-height: 1.35vw;

          p:not(:last-child){
            /*text-align-last: justify;*/
          }
        }
      }

    }
  }
</style>




// WEBPACK FOOTER //
// src/view/about/p5-culture.vue